<svelte:head>

    <link rel='stylesheet' href='/global.css' />

</svelte:head>

<script>

    import {
        getMembersList,
        createMember
    } from "../api.svelte";

    import {getContext, onMount} from "svelte";

    import { Dropdown } from "carbon-components-svelte";
    import {checkUnauthorized} from "../../utils/session";

    const router = getContext('router');

    const MEMBER_STATUS_TEXT = {
        'pending': 'Erstellt',
        'active': 'Aktiv',
        'blocked': 'Geblockt'
    };

    let currentOverlay = 'none';

    let memberList = false;
    let listSearchQuery = '';
    let listFilterQuery = 'active';

    let memberCreateLoading = false;
    let memberName = '';
    let memberCategory = 'supermarket';
    let memberContact = '';
    let memberAddress = { 'street': '', 'zip': '', 'city': '', 'number': '' };
    let isExternal = false;

    $: inSearchQuery = (member) => {

        if (listSearchQuery === '') {

            return true;
        }

        const searchQuery = listSearchQuery.toLowerCase();

        return member['company']['name'].toLowerCase().includes(searchQuery)
            || member['company']['title'].toLowerCase().includes(searchQuery)
            || member['status'].toLowerCase().includes(searchQuery)
            || member['company']['contact'].toLowerCase().includes(searchQuery)
            || member['company']['address']['street'].toLowerCase().includes(searchQuery)
            || member['company']['address']['zip'].toLowerCase().includes(searchQuery)
            || member['company']['address']['city'].toLowerCase().includes(searchQuery);

    };


    onMount(() => {

        handleGetMembers();

    });


    let handleGetMembers = () => {

        getMembersList().then((listResult) => {

            if (listResult['status'] !== 'success') {

                checkUnauthorized(router, listResult);
                console.log(listResult);
                return;

            }

            memberList = listResult['members'];
            console.log(memberList);

        });

    };

    const getAddressLine = (address) => {

        return address['street'] + ', ' + address['zip'] + ' ' + address['city'];
    };

    const handleOpenDetail = (id) => {

        window.open(`members/${id}`);
    };

    let handleCreateMember = () => {

        if (memberName === '' || memberContact === '' || memberAddress['street'] === ''
            || memberAddress['zip'] === '' || memberAddress['city'] === '') {

            // TODO: errore
            return;

        }

        let binaryExternal = isExternal ? 1 : 0;

        createMember(memberName, memberContact, memberAddress, binaryExternal).then((createResult) => {

            if (createResult['status'] !== 'success') {

                checkUnauthorized(router, createResult);
                console.log(createResult);
                return;

            }

            handleGetMembers();
            currentOverlay = 'none';
            isExternal = false;

        });

    };

    let changeOverlay = (mode) => {

        currentOverlay = mode;
    };

</script>


<div id="members-container">

    <div id="header">

        <h1>Mitglieder</h1>

        {#if currentOverlay === 'none'}

            <button
                    id="member-create"
                    on:click={() => changeOverlay('create')}
                    class="btn entity-add">

                <span>Mitglied hinzufügen</span>

            </button>

        {/if}

    </div>

    {#if currentOverlay === 'none'}

        <div id="members-list">

            <div id="list-filter-container">

<!--                <img src="./images/icons/filter.svg" alt="">-->

                <span>Filtern nach Status:</span>

                <Dropdown
                        bind:selectedId={listSearchQuery}
                        class="dropdown-select"
                        items={[
                            { id: 'active', text: 'Aktiv' },
                            { id: 'pending', text: 'Ausstehend' },
                            { id: '', text: 'Alle' },
                        ]} />
            </div>

            <div id="list-search-container">

                <input
                        bind:value={listSearchQuery}
                        id="list-search"
                        placeholder="Suchen ..." />

                {#if listSearchQuery !== ''}

                    <img
                            on:click={() => listSearchQuery = ''}
                            src="images/icons/close.svg" alt="Reset" />

                {/if}

            </div>

            <table>

                <tr class="header-row">

                    <th id="list-company">Firma</th>
                    <th id="list-status">Status</th>
                    <th id="list-contact">Kontakt</th>
                    <th id="list-address">Addresse</th>
                    <th id="list-external">Ist Mitglied</th>

                </tr>

                {#if memberList}

                    {#each memberList as member}

                        {#if inSearchQuery(member)}

                            <tr on:click={() => handleOpenDetail(member['id'])}>

                                <td>{member['company']['name']}</td>
                                <td>{MEMBER_STATUS_TEXT[member['status']]}</td>
                                <td>{member['company']['contact']}</td>
                                <td>{getAddressLine(member['company']['address'])}</td>
                                <td>{member['external'] ? "Nein" : "Ja"}</td>

                            </tr>

                        {/if}

                    {/each}

                {/if}

            </table>

        </div>

    {/if}

</div>

{#if currentOverlay === 'create'}

    <div
            id="assistant-create"
            class="assistant"
            on:click|self={() => currentOverlay = 'none'}>

        <div class="assistant-container">

            <div
                    on:click={() => changeOverlay('none')}
                    class="assistant-close">

                <img src="images/icons/close.svg" alt="Close" />

            </div>

            <input
                    bind:value={memberName}
                    name="name"
                    type="text"
                    placeholder="Name der Firma" />

            <input
                    bind:value={memberContact}
                    name="contact"
                    type="text"
                    placeholder="Kontaktperson" />

            <input
                    bind:value={memberAddress['street']}
                    name="street"
                    type="text"
                    placeholder="Strasse" />

            <input
                    bind:value={memberAddress['number']}
                    name="street"
                    type="text"
                    placeholder="Nr." />

            <input
                    bind:value={memberAddress['zip']}
                    name="zip"
                    type="text"
                    maxlength="4"
                    placeholder="PLZ" />

            <input
                    bind:value={memberAddress['city']}
                    name="city"
                    type="text"
                    placeholder="Ort" />

            <label>
                Kein Mitglied?
                <input
                        bind:checked={isExternal}
                        type="checkbox" />
            </label>


            <button
                    on:click={() => handleCreateMember()}
                    class="{(memberCreateLoading) ? 'loading btn' : 'btn'}">

                <span>Hinzufügen</span>
                <img src="images/loader/button-loader.svg" />

            </button>

        </div>

    </div>

{/if}


<style>

    #members-container {
        position: relative;
        display: flex;
        flex-direction: column;
        width: calc(100vw - 40vh);
        padding-top: 4vh;
    }

    .assistant {
        width: calc(100vw - 28vh);
        height: 100vh;
    }

    .assistant-container input,
    .assistant-container button,
    .assistant-container :global(.dropdown-select button),
    .assistant-container :global(.bx--list-box__menu) {
        width: 28vh;
        padding: 1.42vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

    .assistant-container button {
        margin-bottom: 0;
    }

    #members-list {
        position: relative;
        display: flex;
        flex-direction: column;
        align-self: center;
        align-items: center;
        width: fit-content;
        min-height: 50vh;
        padding: 4vh;
        margin-top: 12vh;
        border-radius: 1.5vh;
        font-family: 'Urbanist', sans-serif;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
        box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.08);
    }

    #list-filter-container {
        position: absolute;
        top: 3vh;
        left: 4vh;
        display: flex;
        align-items: center;
    }

    #list-filter-container img {
        height: 2vh;
    }

    #list-search-container {
        position: absolute;
        top: 3vh;
        right: 3vh;
    }

    #list-search {
        width: 26vh;
        height: 3vh;
        padding: 0.75vh 1.5vh;
        font-size: 1.5vh;
    }

    #list-search-container img {
        position: absolute;
        top: 0.75vh;
        right: 1.5vh;
        width: 1.25vh;
        height: 1.25vh;
        cursor: pointer;
    }

    table {
        margin-top: 6vh;
        border-spacing: 0;
    }

    table tr {
        transition: all 0.2s ease;
    }

    table tr:not(.header-row):hover {
        cursor: pointer;
        background-color: rgba(123, 194, 255, 0.075);
    }

    table th, table td {
        padding: 0.75vh;
        font-size: 1.5vh;
    }

    table th {
        font-weight: 500;
        text-align: left;
    }

    th#list-company {
        width: 16vh;
    }

    th#list-status {
        width: 10vh;
    }

    th#list-contact {
        width: 18vh;
    }

    th#list-address {
        width: 26vh;
    }

    label {
        display: flex;
    }

    .assistant-container label input {
        width: unset;
    }

    #list-filter-container span {
        margin-right: 1vh;
    }

</style>
